const setQueryParamsToString = (query) => {
  if (!query) {
    return '';
  }
  const { tab, ...queryParams } = query;
  return Object.entries(queryParams)
    .reduce((queryString, item) => {
      const key = item?.[0];
      const value = item?.[1];
      if (typeof value === 'undefined') {
        return queryString;
      }
      return queryString + `${key}=${value}&`;
    }, '?')
    .slice(0, -1);
};

export default setQueryParamsToString;
